namespace RioERP.Reports {
    export interface B2CForm {
        InvoiceDate: Serenity.DateEditor;
        Invoicenumber: Serenity.StringEditor;
        EPaymentType: Serenity.EnumEditor;
        PaymentSource: Serenity.StringEditor;
        CustomerName: Serenity.StringEditor;
        StateName: Serenity.StringEditor;
        Quantity: Serenity.IntegerEditor;
        SpecificationName: Serenity.StringEditor;
        Views: Serenity.EnumEditor;
        Validity: Serenity.EnumEditor;
        HsnCode: Serenity.StringEditor;
        TaxCategoryName: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        TaxRate: Serenity.DecimalEditor;
        TaxableAmount: Serenity.DecimalEditor;
        CgstAmount: Serenity.DecimalEditor;
        SgstAmount: Serenity.DecimalEditor;
        IgstAmount: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        OrderNumber: Serenity.StringEditor;
        City: Serenity.StringEditor;
        DiscountAmount: Serenity.DecimalEditor;
        Gstin: Serenity.StringEditor;
        OrderDate: Serenity.DateEditor;
    }

    export class B2CForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.B2C';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!B2CForm.init)  {
                B2CForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.EnumEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.DecimalEditor;

                Q.initFormType(B2CForm, [
                    'InvoiceDate', w0,
                    'Invoicenumber', w1,
                    'EPaymentType', w2,
                    'PaymentSource', w1,
                    'CustomerName', w1,
                    'StateName', w1,
                    'Quantity', w3,
                    'SpecificationName', w1,
                    'Views', w2,
                    'Validity', w2,
                    'HsnCode', w1,
                    'TaxCategoryName', w1,
                    'ProductName', w1,
                    'TaxRate', w4,
                    'TaxableAmount', w4,
                    'CgstAmount', w4,
                    'SgstAmount', w4,
                    'IgstAmount', w4,
                    'NetAmount', w4,
                    'OrderNumber', w1,
                    'City', w1,
                    'DiscountAmount', w4,
                    'Gstin', w1,
                    'OrderDate', w0
                ]);
            }
        }
    }
}
